export const timeRegEx = /^(00|10|11|12|[1-9]):([0-5][0-9])(am|pm)$/i;
